import { Link, NavLink } from "react-router-dom";
import { Moon, Sun, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme";

export default function Navigation() {
  const { theme, toggle } = useTheme();

  const linkClass = ({ isActive }) =>
    `font-ui text-sm tracking-wide link-soft ${
      isActive ? "text-secondary font-semibold" : "text-foreground/80 hover:text-foreground"
    }`;

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur-md"
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-6">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-2 group">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-secondary text-secondary-foreground">
            <BookOpen className="h-4 w-4" strokeWidth={1.7} />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-xl text-foreground tracking-tight">NewWaysToday</span>
            <span className="font-ui text-[10px] uppercase tracking-[0.25em] text-muted-foreground mt-1">
              Field Guide
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <NavLink to="/read" data-testid="nav-read" className={linkClass}>Read Online</NavLink>
          <NavLink to="/#signup" data-testid="nav-signup" className={linkClass}>Get Free Book</NavLink>
          <NavLink to="/contact" data-testid="nav-contact" className={linkClass}>Contact</NavLink>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={toggle}
            data-testid="dark-mode-toggle"
            aria-label="Toggle dark mode"
            className="rounded-full"
          >
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </Button>
        </div>
      </nav>
    </header>
  );
}
